import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { debounceTime, distinctUntilChanged, switchMap, filter, tap, catchError } from 'rxjs/operators';
import { CaseApi } from 'shared/sdk';
import { CommonService } from 'shared/services/common.service';

@Component({
  selector: 'app-partner-case-num-lookup',
  templateUrl: './partner-case-num-lookup.component.html',
  styleUrls: ['./partner-case-num-lookup.component.scss']
})
export class PartnerCaseNumLookupComponent implements OnInit {
  @Input() set resetData(isClear) {
    // this.partnerCaseIds = [];
    this.partnerCaseObj = [];
  }
  @Input() placeholder;
  @Output() getPMSCaseIdsObj: EventEmitter<any> = new EventEmitter();

  partnerCaseObj: any
  partnerCaseIds: any

  public searchInput = new EventEmitter<string>();
  itemsPerBatch = 50;
  notFoundText: string;
  orderBy = 'id DESC';

  constructor(private _caseApi: CaseApi,
    private _commonService: CommonService) {
  }

  ngOnInit() {
    this.placeholder = this.placeholder === undefined ? 'Filter by Partner Case Number' : this.placeholder;
    this.notFoundText = 'Partner Case Number Not Found';
    this.getPMSCaseIds();
    const preselected = localStorage.getItem('filterObj') ? JSON.parse(localStorage.getItem('filterObj')) : '';
    this.partnerCaseObj = (preselected && preselected['partnerCaseNumber']) ? preselected['partnerCaseNumber'] : [];
    if(this.partnerCaseObj.length){
       this.partnerCaseIds = this.partnerCaseObj.map((item: string) => {
        return {
          sfdcId: item,
          label: item,
          value: item,
          Partner_Case_Number__c: item,
        };
      });
      console.log('partnerCaseIds', this.partnerCaseIds);
    }
  }

  getPMSCaseIds() {
    this.searchInput
      .pipe(
        filter(search => search && search.length > 2),
        debounceTime(200),
        distinctUntilChanged(),
        switchMap(search => this.loadPMSCaseIds(search))
      ).subscribe(
        x => {
          this.partnerCaseIds = x.map((item: any) => {
              return {
                sfdcId: item.Partner_Case_Number__c,
                label: item.Partner_Case_Number__c,
                value: item.Partner_Case_Number__c,
                Partner_Case_Number__c: item.Partner_Case_Number__c,
              };
            });
          console.log('partnerCaseIds', this.partnerCaseIds);
          this.notFoundText = (this.partnerCaseIds.length === 0) ? 'Partner Case Number not found.' : '';
        },
        err => {
          console.log(err);
          this.partnerCaseIds = [];
        }

      );
  }
  loadPMSCaseIds(search) {
    if (this._commonService.pmsRecordType['all']) {
      const filters = {
        where:{
        RecordTypeId: { inq: this._commonService.pmsRecordType['all'] },
        Partner_Case_Number__c: { ilike: '%' + search.trim() + '%', options: 'i' }
      },
        fields: ['sfdcId', 'Partner_Case_Number__c']
      }
      return this._caseApi.find(filters);
    } else {
      return [];
    }

  }
  clearPMSCaseIds() {
    this.partnerCaseObj = [];
    this.notFoundText = 'Type to search Partner Case Number';
    this.getPMSCaseIdsObj.emit([]);
  }

  onPMSCaseIdChange() {
    this.getPMSCaseIdsObj.emit(this.partnerCaseObj);
  }

}
